export default "__VITE_ASSET__jp7HF0Gw__"